const getPropMapByConcept = (existingQueryProperties) =>
  existingQueryProperties.reduce(
    (acc, prop) => ({
      ...acc,
      [prop.conceptName]: acc[prop.conceptName] ? [...acc[prop.conceptName], prop] : [prop],
    }),
    {}
  );

export default getPropMapByConcept;
